























import { log } from '@/log'
import {
  AvailablePaidMembershipPlanInGroup
} from '@/models/api/paid-member-price/member-plan/group/available-paid-membership-plan-group'
import DescriptionOfPlans from '@spa/components/organisms/paid-membership/description/DescriptionOfPlans.vue'
import {
  ChangePlanInteraction,
  PlanState,
} from '@spa/components/pages/paid-membership/change/model/interaction'
import { PageBuilder, PageParts } from '@spa/components/pages/paid-membership/change/model/page-builder'
import { State } from '@spa/components/pages/paid-membership/change/model/state'
import LoadingMixin from '@spa/mixins/loading'
import { none, Option, some } from 'fp-ts/lib/Option'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'
@Component({
  components: { DescriptionOfPlans },
})
export default class ChangePlan extends Mixins<LoadingMixin>(LoadingMixin) {
  @Prop({ required: true })
  readonly groupId: string

  @Prop({ required: true })
  readonly beforePlanId: string

  @Prop({ required: true })
  readonly afterPlanId: string

  @Prop({ required: true })
  readonly interaction: ChangePlanInteraction

  @Prop({ required: true })
  readonly pageBuilder: PageBuilder

  before: AvailablePaidMembershipPlanInGroup | null = null
  after: AvailablePaidMembershipPlanInGroup | null = null
  state: State  = 'not-initialized'

  get planState(): Option<PlanState> {
    return this.before !== null && this.after !== null
      ? some({ before: this.before, after: this.after })
      : none
  }
  get pageParts(): PageParts {
    return this.pageBuilder.buildFor(this.state)
  }

  get isLoading(): boolean {
    return this.state === 'loading'
  }

  async created() {
    this.state = 'loading'

    const res = await this.interaction.initialize({
      groupId: this.groupId,
      beforePlanId: this.beforePlanId,
      afterPlanId: this.afterPlanId,
    })

    res.fold(
      ({ error, appState }) => {
        log.error(error)

        this.state = appState
      },
      ({ appState, planState }) => {
        this.before = planState.before
        this.after = planState.after
        this.state = appState
      }
    )
  }

  onChange() {
    if (this.state === 'change-succeed') {
      log.warn('plan-change already succeed')

      return
    }

    this.planState.foldL(
      () => {
        log.error('state not initialized yet')

        this.state = 'change-failed'
      },
      async (state) => {
        this.state = 'loading'
        const res = await this.interaction.change(state)

        res.fold(
          ({ error, appState }) => {
            log.error(error)

            this.state = appState
          },
          (appState) => {
            this.state = appState
          }
        )
      }
    )
  }
}
